import {Formik} from 'formik';
import {isEmpty} from 'main/utility/CommonUtil';
import {getFormInitialValues} from 'main/utility/LayoutUtil';
import {useLayoutId} from 'pages/uiwisePages/UiWiseLayout';
import PropTypes from 'prop-types';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import ConfirmDialog from './ConfirmDialog';

const AppConfirmDialog = ({
  widgetid,
  alertSpec = {},
  isOpen,
  onClose,
  onConfirm,
}) => {
  const layoutId = useLayoutId();
  const widgetSpec = useSelector(({commonReducer}) => {
    if (!isEmpty(alertSpec)) {
      return alertSpec;
    }
    const layout = commonReducer.layoutSpecsById[layoutId];
    return layout?.widgets?.find((w) => w.widgetid === widgetid) ?? null;
  });

  // Early return if no spec is found
  if (!widgetSpec) return null;

  const {fields = []} = widgetSpec;
  const initialValues = useMemo(() => {
    return getFormInitialValues(fields);
  }, [widgetid, fields]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onConfirm}
    >
      {({submitForm, resetForm}) => (
        <ConfirmDialog
          widgetid={widgetid}
          alertSpec={widgetSpec}
          isOpen={isOpen}
          onConfirm={submitForm}
          onClose={() => {
            onClose();
            resetForm();
          }}
        />
      )}
    </Formik>
  );
};

AppConfirmDialog.propTypes = {
  widgetid: PropTypes.string.isRequired,
  alertSpec: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default AppConfirmDialog;
